var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5348 2.615C9.72983 2.535 8.92483 2.475 8.11483 2.43V2.425L8.00483 1.775C7.92983 1.315 7.81983 0.625 6.64983 0.625H5.33983C4.17483 0.625 4.06483 1.285 3.98483 1.77L3.87983 2.41C3.41483 2.44 2.94983 2.47 2.48483 2.515L1.46483 2.615C1.25483 2.635 1.10483 2.82 1.12483 3.025C1.14483 3.23 1.32483 3.38 1.53483 3.36L2.55483 3.26C5.17483 3 7.81484 3.1 10.4648 3.365C10.4798 3.365 10.4898 3.365 10.5048 3.365C10.6948 3.365 10.8598 3.22 10.8798 3.025C10.8948 2.82 10.7448 2.635 10.5348 2.615Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61487 4.07C9.49487 3.945 9.32987 3.875 9.15987 3.875H2.83987C2.66987 3.875 2.49987 3.945 2.38487 4.07C2.26987 4.195 2.20487 4.365 2.21487 4.54L2.52487 9.67C2.57987 10.43 2.64987 11.38 4.39487 11.38H7.60487C9.34987 11.38 9.41988 10.435 9.47487 9.67L9.78487 4.545C9.79487 4.365 9.72987 4.195 9.61487 4.07ZM6.82987 8.875H5.16487C4.95987 8.875 4.78987 8.705 4.78987 8.5C4.78987 8.295 4.95987 8.125 5.16487 8.125H6.82987C7.03487 8.125 7.20487 8.295 7.20487 8.5C7.20487 8.705 7.03487 8.875 6.82987 8.875ZM7.24987 6.875H4.74987C4.54487 6.875 4.37487 6.705 4.37487 6.5C4.37487 6.295 4.54487 6.125 4.74987 6.125H7.24987C7.45487 6.125 7.62487 6.295 7.62487 6.5C7.62487 6.705 7.45487 6.875 7.24987 6.875Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.be1a12af906be598ff14c4ba0a27cb11.svg";
export { ForwardRef as ReactComponent };